import _unset from 'lodash-es/unset';
import _cloneDeep from 'lodash-es/cloneDeep';
import _forEach from 'lodash-es/forEach';
import _set from 'lodash-es/set';
import _keys from 'lodash-es/keys';
import _values from 'lodash-es/values';
import _last from 'lodash-es/last';
import _merge from 'lodash-es/merge';
import _toNumber from 'lodash-es/toNumber';
import _isString from 'lodash-es/isString';

declare var wenji: any;

//Core Service
import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from "libraries/service/api/api.service";
import { Observable } from 'rxjs';

//App Service
import { HttpClient } from '@angular/common/http';
import { SynchronymeService } from "../synchronyme/synchronyme.service";

export interface IRequestContainer {
    rq: any;
    id?: string | number;
}

@Injectable()
export class PnrService extends ApiService {

    public counter = -1;

    public showPnrEvent: EventEmitter<string> = new EventEmitter();
    public showNamelistOrNamelistEvent: EventEmitter<string> = new EventEmitter();
    public showFutureNamelists: EventEmitter<any[]> = new EventEmitter();

    public f_insert: boolean;

    private readonly synchronymeData: any;

    constructor(
        public http: HttpClient,
        private readonly synchronyme: SynchronymeService,
    ) {
        super(http);
        this.synchronymeData = this.synchronyme.data;
        this.initRoot();
        this.initMe();
    }

    public count(): number {
        return this.counter--;
    }

    public showPnr(_id: string): void {
        this.showPnrEvent.emit(_id);
    }

    public showNamelist(_id: string): void {
        this.showNamelistOrNamelistEvent.emit(_id);
    }

    public showFutureNamelist(namelists: any[]): void {
        this.showFutureNamelists.emit(namelists);
    }

    public getPnr(_id: string): Observable<any> {
        if (this.synchronymeData.urlParams.type) {
            return this.sendToApi(this.synchronymeData.urlParams.type, _id, 'pnr');
        } else {
            return this.sendToApi('getPnr', _id, '', true);
        }
    }

    public getPnrAir(_id: string): Observable<any> {
        if (this.synchronymeData.urlParams.type) {
            return this.sendToApi(this.synchronymeData.urlParams.type, _id, 'pnr');
        } else {
            return this.sendToApi('getPnrAir', _id, '', true);
        }
    }

    public getTigre(_id: string): Observable<any> {
        if (this.synchronymeData.urlParams.type) {
            return this.sendToApi(this.synchronymeData.urlParams.type, _id, 'pnr');
        } else {
            return this.sendToApi('getTigre', _id, '', true);
        }
    }

    public createPnr(_query: any): Observable<any> {

        const query = _cloneDeep(_query);

        //remove json flags
        _unset(query, 'created');
        _unset(query, 'topic');

        //set new traveller ids to negative
        const newTraveller = this.setNegativeIndexToNewPax(query.traveller);

        _forEach(newTraveller, (_v: any, _k: any) => {
            if (!_v.booking) {
                _set(_v, 'booking.code', _values(query.booking.code)[0]);
                _set(_v, 'booking.status', 'Confirm');
                _set(_v, 'booking.host', _keys(query.booking.code)[0]);
            }
        });

        query.traveller = newTraveller;

        let tempName: string;
        if (query.journey.booking) {
            if (query.journey.booking.type === "NAMELIST") {
                tempName = query.journey.booking.document;
            } else if (query.journey.booking.type === "PNR") {
                tempName = query.journey.booking.code;
                _set(query, 'code', query.journey.booking.code);
            }
        } else if (query.booking) {

            _set(query, 'journey.booking.code', _values(query.booking.code)[0]);
            _set(query, 'journey.booking.type', 'PNR');
            if (query.booking.isPassive) {
                _set(query, 'journey.booking.isPassive', query.booking.isPassive);
            }
            _set(query, 'journey.booking.host', _keys(query.booking.code)[0]);
            _unset(query, 'booking');
        }

        //dummy or not
        if (this.synchronymeData.urlParams.type) {
            return this.sendToApi('file', tempName + "PutRs", 'pnr');
        } else {

            return this.sendToApi('createPnr', query, '', true);
        }
    }


    public createPatchRq(namelist): IRequestContainer {
        const query = _cloneDeep(namelist);
        const patchQuery: any = {};

        _set(patchQuery, 'sector', query.booking.sector);
        // _set(patchQuery, 'traveller', query.booking.sector)
        //remove json flags
        _unset(query, 'created');

        //set new traveller ids to negative
        const newTraveller = this.setNegativeIndexToNewPax(query.booking.traveller);
        _set(patchQuery, 'traveller', newTraveller);

        //journey
        let destination: string;
        if (_last(_values(query.booking.sector)).to.city.code === query.booking.mainDestination.city.code) {
            destination = 'OneWay';
        } else {
            destination = 'Return';
        }

        _set(patchQuery, 'journey.destination', destination);
        _set(patchQuery, 'journey.from', _values(query.booking.sector)[0].from);
        _set(patchQuery, 'journey.to', query.booking.mainDestination);
        _set(patchQuery, 'journey.begin', _values(query.booking.sector)[0].begin);
        _set(patchQuery, 'journey.end', _last(_values(query.booking.sector)).end);
        _set(patchQuery, 'journey.carrier', query.booking.mainCarrier);


        //journey.booking
        _set(patchQuery, 'journey.booking.code', query.booking.code);
        _set(patchQuery, 'journey.booking.host', _keys(query.booking.code)[0]);
        _set(patchQuery, 'journey.booking.type', 'PNR');
        if (query.booking.isPassive) {
            _set(patchQuery, 'journey.booking.isPassive', true);
        }

        _set(patchQuery, 'stock.Purchased.quantity', 99);

        return {
            rq: patchQuery
        };
    }

    public requestIfLoadedPnr(namelist: any): IRequestContainer {
        const query = _cloneDeep(namelist);

        //re-facto and move the booking object
        const booking: {
            code?: string,
            host?: string,
            type?: string,
            status?: string,
            isPassive?: string
        }={};

        //refacto of booking
        if(typeof query.booking.code === "object"){
            booking.code = Object.values(query.booking.code)[0] as string;
            booking.host = Object.keys(query.booking.code)[0];
        }else{
            booking.code = query.booking.code;
            booking.host = query.booking.host;
        }
        booking.type = "PNR";
        if(query.booking.status){
            booking.status = query.booking.status;
        }

        booking.isPassive = query.booking.isPassive ? query.booking.isPassive: false;

        //set the proper booking object at the right place
        _set(query, 'journey.booking', booking);
        _unset(query, 'booking');

        _unset(query, 'created');

        return query;
    }


    public createUpdatePnr(namelist: any): IRequestContainer {
        const query: any = {};

        //set new traveller ids to negative
        const newTraveller = this.setNegativeIndexToNewPax(namelist.traveller);
        const modifiedTraveller = this.getModifiedPax(namelist.traveller);
        _merge(newTraveller, modifiedTraveller);
        query.traveller = newTraveller;

        return {
            rq: query,
            id: namelist.journey.id,
        };
    }


    /**
     * setNegativeIndexToNewPax
     * Detect new travellers, set index negative
     *
     * @param {any} _traveller : complete traveller collection of PNR/namelist
     *
     * @return {any} : collection of newly added pax
     */
    public setNegativeIndexToNewPax(_traveller: any): any {

        const newTraveller: any = {};

        _forEach(_traveller, (value: any, key: string) => {
            if (_toNumber(key) < 0 || value.isAdded) {
                _unset(value, 'isAdded');
                if (value.id && _toNumber(value.id) < 0) {
                    _set(newTraveller, value.id, value);
                } else {
                    _set(newTraveller, this.count(), value);
                }
            }
        });
        return newTraveller;
    }

    /**
     * getmodifiedPax
     * Detect modified pax, and just keep modified datas
     *
     * @param {any} _traveller : complete traveller collection of PNR/namelist
     *
     * @return {any} : collection of newly added pax
     **/
    public getModifiedPax(_traveller: any): any {

        const modifiedTraveller: any = {};
        _forEach(_traveller, (_value: any, _key: string) => {
            if (_value.dataToPatch) {
                modifiedTraveller[_key] = _value.dataToPatch;
            }
        });
        return modifiedTraveller;
    }

    /**
     *  wrapData
     *
     * to be overwrited in inherited services
     * in not overwrited, return _reponse
     *
     * @param {any} _response        : data to store
     */
    public wrapData(_responseData: any): any {


        let key: string;
        const object: any = {};
        let booking: any = {};

        if (_responseData.topic && _responseData.topic === "Journey") { //Journey
            booking = _responseData.journey.booking;
        } else { //PNR Air
            booking = _responseData.booking;
        }

        if (_isString(booking.code)) {
            key = booking.code;
        } else {
            key = _values(booking)[0].code;
        }

        object[key] = _responseData;
        return object;

    }


    public additionalStore(_response: any, _storePath: string, _canReplace: boolean = false): void {
        //get response sectors
        let responseSector: any = {};
        let responseJourney: any = {};
        if (_values(_response)[0].sector && _values(_response)[0].journey) {
            responseSector = _values(_response)[0].sector;
            responseJourney = _values(_response)[0].journey;
        } else {
            responseSector = _values(_response)[0].booking.sector;
        }


        const key = _keys(_response)[0];

        // Store response sectors and compare sectors
        if (this.synchronyme.storeThenCompareSector(responseSector, responseJourney)) {
            this.f_insert = true;
        } else {
            this.f_insert = false;
            _unset(this.response.data.pnr, key);

        }

    }

    public initMe(): void {
        this.galileo.target = wenji.synchronyme.api.galileo.target;
    }

}
